import { render, staticRenderFns } from "./CaseMemberDatabox.vue?vue&type=template&id=0f75621e&lang=pug&"
import script from "./CaseMemberDatabox.vue?vue&type=script&lang=js&"
export * from "./CaseMemberDatabox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports